import { render } from "./ReliefNewList.vue?vue&type=template&id=ec7289fe&scoped=true"
import script from "./ReliefNewList.vue?vue&type=script&lang=js"
export * from "./ReliefNewList.vue?vue&type=script&lang=js"

import "./ReliefNewList.vue?vue&type=style&index=0&id=ec7289fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7289fe"]])

export default __exports__